import { ProductInfoModel } from "./product-info-model";

export class CheckoutInfoModel {
    products: Array<ProductInfoModel> = new Array();
    signUrl =  `${window.location.protocol + "//" + window.location.host + '/auth/pdfviewersignature'}`;
}
